export const packagingCode = {
  0: 'BASE_UNIT_OR_EACH',
  1: 'PACK_OR_INNER_PACK',
  2: 'CASE',
  3: 'PALLET'
};

export const packagingType = {
  BASE_UNIT_OR_EACH: 0,
  PACK_OR_INNER_PACK: 1,
  CASE: 2,
  PALLET: 3
};
